/**
 * Deterministic collaboration identity colors.
 *
 * Single source of truth for user colors across all collaboration surfaces:
 * - presence bubbles / avatars
 * - live cursors + labels
 * - comment author colors (future)
 *
 * Color is derived from a stable seed (userId) so the same user
 * always gets the same color regardless of join order or session.
 */

export interface CollabColor {
  bg: string;
  text: string;
}

const PALETTE: CollabColor[] = [
  { bg: '#E05A33', text: '#FFFFFF' },
  { bg: '#1B7A4B', text: '#FFFFFF' },
  { bg: '#5E6AD2', text: '#FFFFFF' },
  { bg: '#9C5BBD', text: '#FFFFFF' },
  { bg: '#D97645', text: '#FFFFFF' },
  { bg: '#4285F4', text: '#FFFFFF' },
  { bg: '#14B8A6', text: '#FFFFFF' },
  { bg: '#EC4899', text: '#FFFFFF' },
];

/** FNV-1a hash — good distribution for short strings like ObjectIds */
function hashFNV1a(input: string): number {
  let hash = 2166136261;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = (hash * 16777619) >>> 0;
  }
  return hash;
}

/**
 * Get a deterministic collaboration color for a user.
 * Same userId always produces the same color.
 */
export function getCollabColor(userId: string): CollabColor {
  return PALETTE[hashFNV1a(userId) % PALETTE.length];
}
